import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { LoteAgendamento } from "../../../../services/LoteAgendamento";
import { ILoteDeliveryForm } from "../../../../types/loteAgendamento";

export const useVincularDeliveryLoteAgendamento = () => {
  return useMutation({
    mutationFn: (data: ILoteDeliveryForm) =>
      LoteAgendamento.vincularDelivery(data),
    onError: ({
      response: {
        data: { mensagem },
      },
    }: any) => {
      toast.error(mensagem);
    },
  });
};
